<template>
	<div class="con">
		<div class="list">
			<label>医院</label>
			<div>{{list.hospital}}</div>
		</div>
		<div class="list">
			<label>科室</label>
			<div>{{list.department}}</div>
		</div>
		<div class="list">
			<label>医生</label>
			<div>{{list.doctor}}</div>
		</div>
		<div class="list">
			<label>支付时间</label>
			<div>{{list.time}}</div>
		</div>
		<div class="list">
			<label>订单金额</label>
			<div>￥{{list.orderPrice}}</div>
		</div>
		<div class="list">
			<label>支付金额</label>
			<div>￥{{list.price}}</div>
		</div>
		<div class="list">
			<label>支付状态</label>
			<div class="colorbe">{{list.orderState}}</div>
		</div>
		<div class="list">
			<label>取药位置</label>
			<div>{{list.medicineAddress}}</div>
		</div>
		<div class="text-btn">
			<van-button class="pay-btn" type="info">去支付</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'paymentRecords',
		data () {
		    return {
		      msg: '住院缴费记录',
		      list:{id: 0,hospital:'广西医科大第一附属医院',department:'五官科',doctor:'张三',orderPrice:'5.50',price:'0',time:'2020-3-23 16:36:00',orderState:'待支付',medicineAddress:'二号窗口'},
		    }
		},
		methods:{
			
			//押金
			GetDepositList() {
				this.$Axios.Get('/getDepositList?brid='+this.cardUserInfo.brid, null).then(data => {
					console.log(data)
					if(data.code == 0) {
						this.List = data.list
					} else {}

				}).catch(err => {
					console.log(err)
				})
			},
			
		},
		mounted(){
			this.GetDepositList();
		},
		created () {
	    },
	}
</script>

<style scoped>
	.list{
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 15px;
	}
	.list label{
		color: #999;
	}
	.colorbe{
		color: #27BEC4;
	}
	.text-btn{
		margin-top: 20px;
		text-align: center;
	}
	.pay-btn{
		width: 80%;
		background-color: #27BEC4;
		border: 1px solid #27BEC4;
	}
</style>

